'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Pager = require('./Pager');

var _Pager2 = _interopRequireDefault(_Pager);

var _WithPaginator = require('./WithPaginator');

var _WithPaginator2 = _interopRequireDefault(_WithPaginator);

var _PaginationOptions = require('./PaginationOptions');

var _PaginationOptions2 = _interopRequireDefault(_PaginationOptions);

var _NaviButton = require('./NaviButton');

var _NaviButton2 = _interopRequireDefault(_NaviButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var outlineAction = {
  NOACTION: 0,
  CLICK: 1,
  CHANGE: 2,
  BLUR: 3,
  TAB: 4
};

var defaultPageSizeOptions = [5, 10, 15, 20];

var Pagination = function (_Component) {
  _inherits(Pagination, _Component);

  function Pagination(props) {
    _classCallCheck(this, Pagination);

    var _this = _possibleConstructorReturn(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));

    _this.renderFieldsPager = function () {
      var _this$props = _this.props,
          calculatePages = _this$props.calculatePages,
          setCurrentPage = _this$props.setCurrentPage,
          current = _this$props.value;

      var pageNums = calculatePages();
      return _react2.default.createElement(_Pager2.default, {
        key: 'pagination-fields',
        kind: 'fields',
        current: current,
        pageNums: pageNums,
        onPageChange: setCurrentPage
      });
    };

    _this.renderNumericPager = function () {
      var _this$props2 = _this.props,
          calculatePages = _this$props2.calculatePages,
          setCurrentPage = _this$props2.setCurrentPage,
          current = _this$props2.value;

      var pageNums = calculatePages();
      var maxCountOfPagers = 5;
      var pagers = [],
          startPager = void 0;
      //push first page
      pagers.push(_react2.default.createElement(_Pager2.default, {
        key: 'pager1',
        kind: 'numeric',
        text: 1,
        current: current,
        pageNums: pageNums,
        onPageChange: setCurrentPage
      }));
      var roundMaxCountOfPagers = Math.round(maxCountOfPagers / 2);
      if (current > roundMaxCountOfPagers + 1) {
        pagers.push(_react2.default.createElement(_Pager2.default, {
          key: 'pager-more-start',
          text: '...',
          current: current,
          kind: 'numeric'
        }));
        if (current <= pageNums - roundMaxCountOfPagers) {
          startPager = current - roundMaxCountOfPagers + 1;
        } else {
          startPager = pageNums - maxCountOfPagers + 1;
        }
      } else {
        startPager = 2;
      }
      var displayCount = maxCountOfPagers;
      if (current < roundMaxCountOfPagers + 1) {
        displayCount = maxCountOfPagers - 1;
      }
      displayCount = Math.min(displayCount, pageNums - 1);

      for (var i = 0; i < displayCount; i++) {
        if (startPager + i === current) {
          pagers.push(_react2.default.createElement(_Pager2.default, {
            kind: 'numeric',
            key: 'pager-' + (startPager + i),
            current: current,
            text: startPager + i,
            pageNums: pageNums,
            onPageChange: setCurrentPage
          }));
        } else {
          pagers.push(_react2.default.createElement(_Pager2.default, {
            kind: 'numeric',
            key: 'pager-' + (startPager + i),
            text: startPager + i,
            current: current,
            pageNums: pageNums,
            onPageChange: setCurrentPage
          }));
        }
      }
      if (pageNums > maxCountOfPagers + startPager) {
        pagers.push(_react2.default.createElement(_Pager2.default, {
          key: 'pager-more-end',
          kind: 'numeric',
          current: current,
          text: '...'
        }));
      }
      if (maxCountOfPagers + startPager <= pageNums) {
        pagers.push(_react2.default.createElement(_Pager2.default, {
          key: 'pager-' + pageNums,
          kind: 'numeric',
          text: pageNums,
          current: current,
          pageNums: pageNums,
          onPageChange: setCurrentPage
        }));
      }
      return pagers;
    };

    _this.renderCarouselPaginator = function () {
      var _this$props3 = _this.props,
          calculatePages = _this$props3.calculatePages,
          current = _this$props3.value,
          setCurrentPage = _this$props3.setCurrentPage;

      var pageNums = calculatePages();
      var pagers = [];
      for (var i = 0; i < pageNums; i++) {
        pagers.push(_react2.default.createElement(_Pager2.default, {
          key: i,
          kind: 'carousel',
          current: current,
          text: i + 1,
          pageNums: pageNums,
          onPageChange: setCurrentPage
        }));
      }
      return pagers;
    };

    _this.renderPrevItem = function () {
      var _ClassNames;

      var _this$props4 = _this.props,
          hasPrev = _this$props4.hasPrev,
          prev = _this$props4.prev;
      var _this$props5 = _this.props,
          renderPrevButton = _this$props5.renderPrevButton,
          _this$props5$kind = _this$props5.kind,
          kind = _this$props5$kind === undefined ? 'default' : _this$props5$kind;

      var prevLinkClasses = (0, _classnames2.default)('a-page a-page-link', (_ClassNames = {}, _defineProperty(_ClassNames, 'disabled', !hasPrev()), _defineProperty(_ClassNames, 'circle', kind === 'numeric'), _ClassNames));
      var renderedPrevBtn = void 0;
      if (renderPrevButton) {
        var prevBtn = renderPrevButton();
        renderedPrevBtn = _react2.default.cloneElement(prevBtn, {
          onClick: prev,
          className: (0, _classnames2.default)(prevBtn.props.className, 'pagination-button pagination-prev')
        });
      } else {
        renderedPrevBtn = _react2.default.createElement(
          _NaviButton2.default,
          { className: '-previous' },
          _react2.default.createElement('span', { className: 'appkiticon icon-left-chevron-fill' })
        );
      }
      return _react2.default.createElement(
        'li',
        { key: 'pagination-prev', className: prevLinkClasses, onClick: prev },
        renderedPrevBtn
      );
    };

    _this.renderNextItem = function () {
      var _ClassNames2;

      var _this$props6 = _this.props,
          hasNext = _this$props6.hasNext,
          next = _this$props6.next;
      var _this$props7 = _this.props,
          renderNextButton = _this$props7.renderNextButton,
          _this$props7$kind = _this$props7.kind,
          kind = _this$props7$kind === undefined ? 'default' : _this$props7$kind;

      var nextLinkClasses = (0, _classnames2.default)('a-page a-page-link', (_ClassNames2 = {}, _defineProperty(_ClassNames2, 'disabled', !hasNext()), _defineProperty(_ClassNames2, 'circle', kind === 'numeric'), _ClassNames2));
      var renderedNextBtn = void 0;
      if (renderNextButton) {
        var nextBtn = renderNextButton();
        renderedNextBtn = _react2.default.cloneElement(nextBtn, {
          onClick: next,
          className: (0, _classnames2.default)(nextBtn.props.className, 'pagination-button pagination-next')
        });
      } else {
        renderedNextBtn = _react2.default.createElement(
          _NaviButton2.default,
          { className: '-next' },
          _react2.default.createElement('span', { className: 'appkiticon icon-right-chevron-fill' })
        )
        // <div
        //   className={ClassNames('-next', {
        //     'without-outline': !this.state.hasOutline
        //   })}
        //   onMouseDown={() => {
        //     this.setState({
        //       hasOutline: false,
        //       lastAction: outlineAction.CLICK
        //     });
        //   }}
        //   onKeyDown={e => {
        //     console.log('onKeyDown====');
        //     if (e.which === 9 || e.keyCode === 9) {
        //       this.setState({
        //         hasOutline: true,
        //         lastAction: outlineAction.TAB
        //       })
        //     }
        //   }}
        // >
        //   <span className="appkiticon icon-right-chevron-fill"></span>
        // </div>
        ;
      }

      return _react2.default.createElement(
        'li',
        { key: 'pagination-next', className: nextLinkClasses, onClick: next },
        renderedNextBtn
      );
    };

    _this.renderPager = function () {
      var _this$props8 = _this.props,
          _this$props8$kind = _this$props8.kind,
          kind = _this$props8$kind === undefined ? 'default' : _this$props8$kind,
          _this$props8$showPrev = _this$props8.showPrevAndNextBtn,
          showPrevAndNextBtn = _this$props8$showPrev === undefined ? true : _this$props8$showPrev;

      var pagers = [],
          leftPager = void 0,
          rightPager = void 0;
      if (showPrevAndNextBtn && kind !== 'carousel') {
        leftPager = _this.renderPrevItem();
        rightPager = _this.renderNextItem();
      }
      if (kind === 'default' || kind === 'simple') {
        pagers.push(_this.renderFieldsPager());
      } else if (kind === 'numeric') {
        pagers = [].concat(_toConsumableArray(pagers), _toConsumableArray(_this.renderNumericPager()));
      } else if (kind === 'carousel') {
        pagers = [].concat(_toConsumableArray(pagers), _toConsumableArray(_this.renderCarouselPaginator()));
      }

      leftPager && pagers.unshift(leftPager);
      rightPager && pagers.push(rightPager);

      return pagers;
    };

    return _this;
  }

  _createClass(Pagination, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          className = _props.className,
          _props$kind = _props.kind,
          kind = _props$kind === undefined ? 'default' : _props$kind,
          total = _props.total,
          hasPrev = _props.hasPrev,
          hasNext = _props.hasNext,
          prev = _props.prev,
          next = _props.next,
          setCurrentPage = _props.setCurrentPage,
          calculatePages = _props.calculatePages,
          showPrevAndNextBtn = _props.showPrevAndNextBtn,
          onChange = _props.onChange,
          _props$showSizeOption = _props.showSizeOptions,
          showSizeOptions = _props$showSizeOption === undefined ? false : _props$showSizeOption,
          renderPrevButton = _props.renderPrevButton,
          renderNextButton = _props.renderNextButton,
          _props$pageSizeOption = _props.pageSizeOptions,
          pageSizeOptions = _props$pageSizeOption === undefined ? defaultPageSizeOptions : _props$pageSizeOption,
          onPageSizeChange = _props.onPageSizeChange,
          changePageSize = _props.changePageSize,
          current = _props.value,
          pageSize = _props.pageSize,
          _props$showTextWithOn = _props.showTextWithOnlyOneOption,
          showTextWithOnlyOneOption = _props$showTextWithOn === undefined ? false : _props$showTextWithOn,
          defaultCurrent = _props.defaultCurrent,
          defaultPageSize = _props.defaultPageSize,
          otherProps = _objectWithoutProperties(_props, ['style', 'className', 'kind', 'total', 'hasPrev', 'hasNext', 'prev', 'next', 'setCurrentPage', 'calculatePages', 'showPrevAndNextBtn', 'onChange', 'showSizeOptions', 'renderPrevButton', 'renderNextButton', 'pageSizeOptions', 'onPageSizeChange', 'changePageSize', 'value', 'pageSize', 'showTextWithOnlyOneOption', 'defaultCurrent', 'defaultPageSize']);

      var paginationClasses = (0, _classnames2.default)(className, _defineProperty({
        'a-pagination': true
      }, 'a-pagination-' + kind, kind !== 'default'));
      if (!showSizeOptions) {
        return _react2.default.createElement(
          'nav',
          Object.assign({
            style: style,
            className: className
          }, otherProps, {
            'aria-label': 'Page navigation'
          }),
          _react2.default.createElement(
            'ul',
            { className: paginationClasses },
            this.renderPager()
          )
        );
      } else {
        var node = _react2.default.createElement(
          'nav',
          { 'aria-label': 'Page navigation' },
          _react2.default.createElement(
            'ul',
            { className: paginationClasses },
            this.renderPager()
          )
        );
        return _react2.default.createElement(
          'div',
          {
            style: style,
            className: (0, _classnames2.default)('clearfix a-pagination-wrapper', className)
          },
          _react2.default.createElement(_PaginationOptions2.default, {
            current: current,
            total: total,
            pageSize: pageSize,
            pageSizeOptions: pageSizeOptions,
            onPageSizeChange: changePageSize,
            showTextWithOnlyOneOption: showTextWithOnlyOneOption
          }),
          node
        );
      }
    }
  }]);

  return Pagination;
}(_react.Component);

Pagination.propTypes = {
  kind: _propTypes2.default.string,
  current: _propTypes2.default.number,
  defaultPageSize: _propTypes2.default.number,
  defaultCurrent: _propTypes2.default.number,
  total: _propTypes2.default.number,
  showPrevAndNextBtn: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  renderPrevButton: _propTypes2.default.func,
  renderNextButton: _propTypes2.default.func,
  pageSize: _propTypes2.default.number,
  pageSizeOptions: _propTypes2.default.arrayOf(_propTypes2.default.number),
  onPageSizeChange: _propTypes2.default.func,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  prev: _propTypes2.default.func,
  next: _propTypes2.default.func,
  hasPrev: _propTypes2.default.func,
  hasNext: _propTypes2.default.func,
  setCurrentPage: _propTypes2.default.func,
  calculatePages: _propTypes2.default.func,
  changePageSize: _propTypes2.default.func,
  value: _propTypes2.default.number
};

Pagination.displayName = 'Pagination';

exports.default = (0, _WithPaginator2.default)(Pagination);